export default __webpack_public_path__ + "static/media/machine.2549e7e3.png";